import React, { useEffect, useState } from 'react';
import { formatDistanceToNowStrict } from 'date-fns';
// import { Typography } from '@mui/material';
import Typography from '@ui/Typography';

const MINUTE_MS = 60000;

const formatUnit = (unit, addSuffix) => {
  if (addSuffix) {
    return ` ${unit} ago`;
  }
  switch (unit) {
    case 'seconds':
    case 'second':
      return 'Just now';
    case 'minutes':
    case 'minute':
      return `m`;
    case 'hours':
    case 'hour':
      return `h`;
    case 'days':
    case 'day':
      return `d`;
    case 'months':
    case 'month':
      return `mo`;
    case 'years':
    case 'year':
      return `y`;
    default:
      return unit;
  }
};

const computeTimeSincePost = (time, addSuffix) => {
  const timeSince = formatDistanceToNowStrict(new Date(time));
  const timeSinceArray = timeSince.split(' ');
  if (timeSinceArray.length === 2) {
    const unit = timeSinceArray[1];
    switch (unit) {
      case 'seconds':
      case 'second':
        return 'Just now';
      default:
        return `${timeSinceArray[0]}${formatUnit(unit, addSuffix)}`;
    }
  }
  return timeSince;
};

function TimeSincePost(props) {
  const { createdOn, variant = null, addSuffix = false } = props;
  const [timeSincePost, setTimeSincePost] = useState(
    computeTimeSincePost(createdOn, addSuffix)
  );

  // update the time since post was created
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeSincePost(computeTimeSincePost(createdOn, addSuffix));
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, [createdOn, addSuffix]);

  if (variant) {
    return (
      <Typography variant={variant} color="textSecondary">
        {timeSincePost}
      </Typography>
    );
  }
  return (
    <Typography fontSize="0.7rem" color="textSecondary">
      {timeSincePost}
    </Typography>
  );
}

export default TimeSincePost;
